import moment from "moment";

const SignRequestByVolumeValidator = (t) => {
  moment.locale("es");
  let validateDate = false;

  let regexs = {
    nameRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,./;:¿?¡!()"'_-]+$/),
    descriptionRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.@/;:¿?¡!()"'_-]+$/),
    commentsRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.@/;:¿?¡!()"'_-]+$/),
    emailRegex: new RegExp(/^[a-zA-ZñÑ0-9._-]+@([a-zA-Z0-9._-]+\.)+[\w-]{2,}$/),
    fileNameRegex: new RegExp(/^[^+]+\.pdf$/),
  };

  let validators = {
    nameValidator: (value) => {
      if (!value) {
        return t("signRequestByVolume.name.required");
      }
      if (value) {
        if (value.length >= 100) {
          return t("signature.request.nameLengthValidator");
        }
        if (value.length >= 0) {
          return regexs.nameRegex.test(value)
            ? ""
            : t("signature.request.nameValidator");
        }
      }
    },
    descriptionValidator: (value) => {
      if (value) {
        return regexs.descriptionRegex.test(value)
          ? ""
          : t("signature.request.descriptionValidator");
      }
    },
    commentsValidator: (value) => {
      if (value.length > 0) {
        return regexs.commentsRegex.test(value)
          ? ""
          : t("signatureRequestProfileData.notes");
      }
    },
    limitDateValidator: (value) => {
      const now = moment().startOf("day").toDate();
      var toDay = moment();
      if (value < now) {
        validateDate = true;
      } else {
        validateDate = false;
      }
      if (!value || validateDate || toDay.diff(value, "days") <= -60) {
        return t("signature.request.limitDateValidator");
      } else {
        return "";
      }
    },
    emailValidator: (value) => {
      if (value !== "" && value !== undefined) {
        if (value.length > 0) {
          return regexs.emailRegex.test(value)
            ? ""
            : t("signature.request.emailValidator");
        }
      } else {
        return t("signature.request.emailValidatorNull");
      }
    },
    fileName: (value) => {
      if (value.length > 0) {
        return regexs.fileNameRegex.test(value)
          ? ""
          : t("dialogEditRegistryByVolume.errorFileName");
      }
    },
  };

  return validators;
};

export default SignRequestByVolumeValidator;
